// Logic Model (API Request/Response)
export interface MerchantPlanApiResponse {
    current_plan: 'free' | 'basic' | 'premium';
    subscription_status: 'active' | 'cancelled' | 'expired';
}

export interface MerchantPlanUpgradeRequest {
    plan_type: 'basic' | 'premium';
}

// UI Model (State Management)
export interface MerchantPlanUIState {
    current_plan: 'free' | 'basic' | 'premium';
    subscription_status: 'active' | 'cancelled' | 'expired';
    isLoading: boolean;
}

// Data Mapper
export const mapApiResponseToUI = (apiData: MerchantPlanApiResponse): MerchantPlanUIState => {
    return {
        current_plan: apiData.current_plan,
        subscription_status: apiData.subscription_status,
        isLoading: false,
    };
};
